import React from 'react';
import { NavBarData } from '../../../../../types';
import { dataEmPrepText } from '../../../../../utility/common-utils';
import './UtilityLinks.scss';

interface UtilityLinksProps {
  navBarData: NavBarData[] | undefined;
}

const UtilityLinks = ({ navBarData }: UtilityLinksProps) => {
  return (
    <div
      className="utility-links-container hmf-flex-grow hmf-py-s hmf-mt-l hmf-mt-lg-0 hmf-px-lg-m hmf-pb-lg-m"
      id="utility-links">
      {navBarData?.map((el) => {
        const key = JSON.stringify(el);
        return (
          <a
            key={key}
            className="utility-links-button hmf-py-xs hmf-px-s hmf-softer-radius hmf-display-flex hmf-justify-content-flex-start hmf-align-items-center"
            href={el.link}
            data-em={`Header_ProgressiveNav_${dataEmPrepText(el.linkTitle)}`}>
            <span className="hmf-display-flex hmf-justify-content-center hmf-align-items-center">
              <span className="utility-link-text hmf-header-bold-xs">{el.linkTitle}</span>
            </span>
          </a>
        );
      })}
    </div>
  );
};

export default UtilityLinks;
